import type { ICvvRequirementInfo } from '../../types/payment';
import type { IPaymentSetupRequestResponse } from '../../queries/payment';
import { PaymentSetupResponseStatus } from '../../types/api/v2/obt/model/payment-setup-response-status';

export function getIsCvvRequiredForPaymentSourceId(
  paymentSourceId: string,
  allPaymentSetupResponse: IPaymentSetupRequestResponse[],
): ICvvRequirementInfo {
  const paymentSetupResponse = allPaymentSetupResponse.find(
    (responseInfo) => responseInfo.requestInfo.paymentSourceId === paymentSourceId,
  );

  if (!paymentSetupResponse) {
    return {
      isCvvRequired: false,
      paymentSourceId,
      status: PaymentSetupResponseStatus.Ok,
    };
  }

  const { status, cvvDocLink } = paymentSetupResponse.response;

  return {
    isCvvRequired:
      status === PaymentSetupResponseStatus.CvvRequired || status === PaymentSetupResponseStatus.SupplierCvvRequired,
    status,
    paymentSourceId,
    cvvDocLink,
  };
}
